import { get } from "aws-amplify/api";
import { API_NAME } from "../lib/amplify";
import { setCertificatePolicies } from "./certificate_policy_store";
import { setDeviceGroups } from "./device_group_store";
import { setCertificates } from "./certificate_store";
import { setDevices } from "./device_store";
import { setCustomerId } from "./customer_id_store";
import type { CertificatePolicy } from "../../../shared/models/certificate_policy";
import type { DeviceGroup } from "../../../shared/models/device_group";
import type { Certificate } from "../../../shared/models/certificate";
import type { Device } from "../../../shared/models/device";

interface ListAccountDataResponse {
  customerId?: string;
  certificatePolicies: CertificatePolicy[];
  deviceGroups: DeviceGroup[];
  certificates: Certificate[];
  devices: Device[];
}

export async function listAccountData(): Promise<ListAccountDataResponse> {
  const { body } = await get({
    apiName: API_NAME,
    path: "/list-account-data",
  }).response;
  const data = (await body.json()) as unknown as ListAccountDataResponse;
  setCustomerId(data.customerId);
  setCertificatePolicies(data.certificatePolicies);
  setDeviceGroups(data.deviceGroups);
  setCertificates(data.certificates);
  setDevices(data.devices);
  return data;
}
